module.exports = "/static/media/lineto-circular-blackItalic.21f1093b.eot";